import { render, staticRenderFns } from "./OpenPollLayout.vue?vue&type=template&id=1b3de88c&scoped=true"
import script from "./OpenPollLayout.vue?vue&type=script&lang=js"
export * from "./OpenPollLayout.vue?vue&type=script&lang=js"
import style0 from "./OpenPollLayout.vue?vue&type=style&index=0&id=1b3de88c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3de88c",
  null
  
)

export default component.exports